export default "__VITE_ASSET__C0jMIE6v__"